import { useIsDeveloper } from '@web/hooks/useIsDeveloper';
import React from 'react';

/** Renders its children only outside the developer portal: product-app providers developers never need. */
export function HideForDeveloper({ children }: React.PropsWithChildren) {
  const { isDeveloperExperience } = useIsDeveloper();

  if (isDeveloperExperience) {
    return null;
  }

  return children;
}
